<template>
  <v-stepper v-model="e1" class="password-stepper">
    <v-stepper-header>
      <v-stepper-step :complete="e1 > 1" step="1" color="greenMain">
        Step-1
      </v-stepper-step>

      <v-divider></v-divider>
      <v-stepper-step :complete="e1 > 2" step="2" color="greenMain">
        Step-2
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step step="3" color="#708AA7"> Password </v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <v-card class="deposit-form create-account-form" :color="$vuetify.theme.dark ? 'transparent' : 'transparent'">
          <v-row dense>
            <v-col cols="12" sm="12" md="12">
              <fieldset>
                <legend>Account Type</legend>
                <v-select ref="accountTypeSelect" v-model="selectedAccountId" solo :items="formatedAccountTypes"
                  item-value="id" item-text="account_type_display" append-icon="mdi-chevron-down"
                  label="Select Account Type" @change="handleAccount" class="custom-select" single-line
                  hide-details="auto">
                </v-select>
                <span v-if="error.accountTypesError" class="error-message">
                  {{ error.accountTypesError }}
                </span>
              </fieldset>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <fieldset>
                <legend>Manager Type</legend>
                <v-select ref="managerSelect" solo v-model="selectedManager" :items="managerTypes"
                  append-icon="mdi-chevron-down" label="Select Manager Type" class="custom-select"
                  hide-details></v-select>
                <span v-if="error.managerError" class="error-message">
                  {{ error.managerError }}
                </span>
              </fieldset>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <fieldset>
                <legend>Leverage</legend>
                <v-select ref="leverageSelect" v-model="selectedLeverage" solo :items="formatedLeverages"
                  item-value="leverage" item-text="displayText" append-icon="mdi-chevron-down" label="Select Leverage"
                  class="custom-select" @change="handleLeverage" hide-details="auto">
                </v-select>
                <span v-if="error.leverageError" class="error-message">
                  {{ error.leverageError }}
                </span>
              </fieldset>
            </v-col>
            <v-col cols="12" sm="12" md="12">
                <fieldset>
                    <legend>Currency <span :style="{ color: this.currency_color }" >{{ this.currency_symbol }}</span></legend>
                    <v-text-field :label="this.currency" single-line solo hide-details class="custom-select" disabled>
                    </v-text-field>
                </fieldset>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-btn class="text-capitalize btn-account" color="greenMain" tile elevation="0"
                @click.prevent="handleNext(2)">
                Next Step
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-stepper-content>
      <v-stepper-content step="2">
        <v-card class="deposit-form create-account-form" :color="$vuetify.theme.dark ? 'transparent' : 'transparent'">
          <v-row dense>
            <v-col cols="12" sm="12" md="12">
              <fieldset>
                <legend>Username</legend>
                <v-text-field label="Ex: John" v-model="selectedUsername" single-line solo hide-details
                  class="custom-select"></v-text-field>
                <span v-if="error.userNameError" class="error-message">
                  {{ error.userNameError }}
                </span>
              </fieldset>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <fieldset>
                <legend>Profit Share(%)</legend>
                <v-text-field label="Ex: 10" :min="1" v-model="selectedProfitShare" single-line solo hide-details type="number"
                  class="custom-select"></v-text-field>
                <span v-if="error.profitShareError" class="error-message">
                  {{ error.profitShareError }}
                </span>
              </fieldset>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <fieldset>
                <legend>Profit Share Time</legend>
                <v-select solo @change="handleProfitShareDuration" :items="profitShareDuration" item-text="title"
                  item-value="value" append-icon="mdi-chevron-down" label="Select Duration" class="custom-select"
                  hide-details></v-select>
                <span v-if="error.durationError" class="error-message">
                  {{ error.durationError }}
                </span>
              </fieldset>
            </v-col>
            <v-row class="d-flex">
              <v-col cols="12" sm="6" md="6">
                <v-btn class="text-capitalize btn-account" color="greenMain" tile elevation="0"
                  @click.prevent="handlePrevious(1)">
                  Previous Step
                </v-btn>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="d-flex justify-end">
                <v-btn class="text-capitalize btn-account" color="greenMain" tile elevation="0"
                  @click.prevent="handleNext(3)">
                  Next Step
                </v-btn>
              </v-col>
            </v-row>
          </v-row>
        </v-card>
      </v-stepper-content>

      <v-stepper-content step="3">
        <v-card class="deposit-form password-field create-account-form"
          :color="$vuetify.theme.dark ? 'transparent' : 'transparent'">
          <v-row>
            <v-col>
              <fieldset>
                <legend>Manager Password</legend>
                <v-text-field label="**************" v-model="password" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show1 ? 'text' : 'password'" counter @click:append="show1 = !show1" single-line solo
                  hide-details class="custom-select"></v-text-field>
              </fieldset>
              <div class="tick-mark justify-start">
                <span>
                  <v-icon small :class="hasMinimumLength ? 'text--green' : 'text--primary'">mdi mdi-check</v-icon>8
                  Characters
                </span>
                <span>
                  <v-icon small :class="hasLowerCase ? 'text--green' : 'text--primary'">mdi mdi-check</v-icon>1
                  Lowercase
                </span>
                <span>
                  <v-icon small :class="hasUpperCase ? 'text--green' : 'text--primary'">mdi mdi-check</v-icon>1
                  Uppercase
                </span>
                <span>
                  <v-icon small :class="hasDigit ? 'text--green' : 'text--primary'">mdi mdi-check</v-icon>1 Digit
                </span>
                <span>
                  <v-icon small :class="hasSpecialCharacter ? 'text--green' : 'text--primary'
                    ">mdi mdi-check</v-icon>1 Special Character
                </span>
              </div>
              <fieldset>
                <legend>Confirm Password</legend>
                <v-text-field v-model="password2" :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show2 ? 'text' : 'password'" counter @click:append="show2 = !show2"
                  label="Write Password Again" single-line solo hide-details class="custom-select"></v-text-field>
                <span v-if="error.passwordError" class="error-message">
                  {{ error.passwordError }}
                </span>
              </fieldset>
              <v-card-actions class="pa-0">
                <v-row class="d-flex">
                  <v-col cols="12" sm="6" md="6">
                    <v-btn class="text-capitalize btn-account" color="greenMain" tile elevation="0"
                      @click.prevent="handlePrevious(2)">
                      Previous Step
                    </v-btn>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-btn class="text-capitalize btn-account" color="greenMain" tile elevation="0"
                      :disabled="!allConditionsMet || loading" :loading="loading" @click.prevent="handleSumbit">
                      Create Account
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-col>
          </v-row>
        </v-card>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { MAM__ACTIONS, TRADING__ACTIONS } from "@/store/action-types";

export default {
  data() {
    return {
      loading: false,
      selectedAccountId: null,
      selectedLeverage: null,
      selectedUsername: null,
      selectedProfitShare: null,
      selectedDuration: null,
      managerTypes: ["MAM", 
      // "PAMM", "COPY TRADE"
    ],
      selectedManager: null,
      profitShareDuration: [
        {
          title: "Daily",
          value: 1,
        },
        {
          title: "Weekly",
          value: 7,
        },
        {
          title: "Monthly",
          value: 30,
        },
      ],
      show1: false,
      show2: false,
      password: "",
      password2: "",
      e1: 1,
      error: {
        accountTypesError: null,
        leverageError: null,
        passwordError: null,
        managerError: null,
        userNameError: null,
        profitShareError: null,
        durationError: null,
      },
      hasMinimumLength: false,
      hasLowerCase: false,
      hasUpperCase: false,
      hasDigit: false,
      hasSpecialCharacter: false,

      currency: "USD",
      currency_color: "#fff",
      currency_symbol: "$",
    };
  },
  computed: {
    ...mapState("mam", ["accountTypes", "leverages", "allStUserNames"]),
    ...mapState("trading", ["leverage_account_type"]),

    formatedLeverages() {
      if (this.leverage_account_type?.length > 0) {
        return this.leverage_account_type.map((item) => {
          const { id, leverage } = item;
          const displayText = `1:${leverage}`;
          return { id, displayText, leverage };
        });
      } else {
        return [];
      }
    },

    formatedAccountTypes() {
      return this.accountTypes.map((item) => {
        const { id, account_type_display } = item;
        return { id, account_type_display };
      });
    },

    allConditionsMet() {
      return (
        this.hasMinimumLength &&
        this.hasLowerCase &&
        this.hasUpperCase &&
        this.hasDigit &&
        this.hasSpecialCharacter &&
        this.password &&
        this.password2 &&
        this.password === this.password2
      );
    },
  },
  watch: {
    password: function () {
      this.hasMinimumLength = this.password.length >= 8;
      this.hasLowerCase = /.*[a-z].*/.test(this.password);
      this.hasUpperCase = /.*[A-Z].*/.test(this.password);
      this.hasDigit = /.*\d.*/.test(this.password);
      this.hasSpecialCharacter = /.*[@$!%*#?&^_-].*/.test(this.password);
    },

    selectedUsername(newVal) {
      if (newVal) {
        const formattedVal = newVal.trim().toLowerCase();
        const isExists = this.allStUserNames.some(
          (username) => username.trim().toLowerCase() === formattedVal
        );
        this.error.userNameError = isExists ? "Username already exists" : null;
      }
    },
  },
  methods: {
    ...mapActions("mam", [
      MAM__ACTIONS.ACCOUNTTYPESANDLEVERAGES,
      MAM__ACTIONS.STUSERNAMES,
      MAM__ACTIONS.OPENNEWMANAGERACCOUNT,
    ]),

    ...mapActions("trading", [TRADING__ACTIONS.LEVERAGEACCOUNTTYPE]),

    resetForm() {
      // Reset all form values
      this.selectedAccountId = null;
      this.selectedLeverage = null;
      this.selectedUsername = null;
      this.selectedProfitShare = null;
      this.selectedDuration = null;
      this.selectedManager = null;
      this.password = "";
      this.password2 = "";
      this.show1 = false;
      this.show2 = false;
      this.e1 = 1;

      // Reset all error states
      this.error = {
        accountTypesError: null,
        leverageError: null,
        passwordError: null,
        managerError: null,
        userNameError: null,
        profitShareError: null,
        durationError: null,
      };

      // Reset password validation states
      this.hasMinimumLength = false;
      this.hasLowerCase = false;
      this.hasUpperCase = false;
      this.hasDigit = false;
      this.hasSpecialCharacter = false;

      // Reset v-select components using refs
      if (this.$refs.accountTypeSelect) {
        this.$refs.accountTypeSelect.reset();
        this.$refs.accountTypeSelect.internalValue = null;
      }

      if (this.$refs.leverageSelect) {
        this.$refs.leverageSelect.reset();
        this.$refs.leverageSelect.internalValue = null;
      }

      if (this.$refs.managerSelect) {
        this.$refs.managerSelect.reset();
        this.$refs.managerSelect.internalValue = null;
      }

      // Force update the components
      this.$nextTick(() => {
        const refs = ['accountTypeSelect', 'leverageSelect', 'managerSelect'];
        refs.forEach(ref => {
          if (this.$refs[ref]) {
            this.$refs[ref].$forceUpdate();
          }
        });
      });
    },

    handleAccount(selectedAccount) {
      let account_type = this.accountTypes.find(acc => acc.id === selectedAccount);
      if(account_type){
        this.currency = account_type.currencies?.currency_name;
        this.currency_symbol = account_type.currencies?.symbol;
        this.currency_color = account_type.currencies?.symbol_color;
      }
      this.selectedAccountId = selectedAccount;
      this[TRADING__ACTIONS.LEVERAGEACCOUNTTYPE](selectedAccount);
    },

    handleLeverage(selectedLeverage) {
      this.selectedLeverage = selectedLeverage;
    },

    handleProfitShareDuration(selectedDuration) {
      this.selectedDuration = selectedDuration;
    },

    handleNext(value) {
      if (value === 2) {
        if (!this.selectedAccountId) {
          this.error.accountTypesError = "Select at least one account type";
        } else {
          this.error.accountTypesError = null;
        }

        if (!this.selectedLeverage) {
          this.error.leverageError = "Select at least one leverage";
        } else {
          this.error.leverageError = null;
        }

        if (!this.selectedManager) {
          this.error.managerError = "Select at least one manager type";
        } else {
          this.error.managerError = null;
        }
      } else if (value === 3) {
        if (!this.selectedUsername) {
          this.error.userNameError = "Username field is required";
        } else {
          this.error.userNameError = null;
        }

        if (!this.selectedProfitShare) {
          this.error.profitShareError = "Profit share field is required";
        } else {
          const profitShareAsNumber = Number(this.selectedProfitShare);
          if (isNaN(profitShareAsNumber)) {
            this.error.profitShareError = "Profit share must be a number";
          } else if (profitShareAsNumber < 1 || profitShareAsNumber >= 100) {
            this.error.profitShareError = "Profit share must be between 1 to 100";
          } else {
            this.error.profitShareError = null;
          }
        }

        if (!this.selectedDuration) {
          this.error.durationError = "Profit share time field is required";
        } else {
          this.error.durationError = null;
        }
      }

      if (!Object.values(this.error).some((err) => err !== null)) {
        this.e1 = value;
      }
    },

    handlePrevious(value) {
      this.e1 = value;
    },

    async handleSumbit() {

      this.error.passwordError = null;

      if (!this.password || !this.password2) {
        this.error.passwordError = "Both password fields are required.";
        return;
      }

      if (this.password !== this.password2) {
        this.error.passwordError = "Passwords do not match.";
        return;
      }

      this.loading = true;

      try {
        const data = {
          newManagerAccount: {
            trading_account_type_id: this.selectedAccountId,
            leverage: this.selectedLeverage,
            password: this.password,
            username: this.selectedUsername,
            // type:
            //   this.selectedManager === "MAM"
            //     ? 0
            //     : this.selectedManager === "PAMM"
            //     ? 1
            //     : this.selectedManager === "COPY TRADE"
            //     ? 2
            //     : null,
            type: this.selectedManager === "MAM" ? 0 : null,
            profit_share: this.selectedProfitShare,
            profit_share_time: this.selectedDuration,
          },
        };

        const response = await this[MAM__ACTIONS.OPENNEWMANAGERACCOUNT](data);

        if (response?.success) {
          this.resetForm();
        } else {
          this.error.passwordError = response?.message || "Account creation failed.";
        }
      } catch (error) {
        console.error('Manager account creation error:', error.message);
        this.error.passwordError = "An error occurred. Please try again.";
      } finally {
        this.loading = false;
      }
    }

  },

  async mounted() {
    await this[MAM__ACTIONS.ACCOUNTTYPESANDLEVERAGES]();
    await this[MAM__ACTIONS.STUSERNAMES]();
  },
};
</script>

<style scoped>
.error-message {
  color: red;
  font-size: 12px;
}
</style>